module.exports = __webpack_public_path__ + "img/120.b87beae1.svg";